// DS: MO3.4.1
import React from 'react';
import DeviationShopCard from '../DeviationShopCard';
const PCPShopCard = ({ width, deviation, withAuthorDetails, withIndicators, withDreamupLabel })=>{
    return /*#__PURE__*/ React.createElement(DeviationShopCard, {
        width: width,
        deviation: deviation,
        withStats: true,
        withPremiumDownloadCount: true,
        withDescriptionBlock: false,
        withAuthorDetails: withAuthorDetails,
        withIndicators: withIndicators,
        withDreamupLabel: withDreamupLabel
    });
};
PCPShopCard.displayName = 'PCPShopCard';
export default PCPShopCard;

//# sourceMappingURL=PCPShopCard.js.map